import React from "react";

const Linked = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M33.992 34v-.002H34V22.263c0-5.742-1.236-10.164-7.948-10.164-3.227 0-5.392 1.77-6.276 3.449h-.093v-2.913h-6.364v21.363h6.626V23.42c0-2.786.528-5.479 3.977-5.479 3.4 0 3.45 3.179 3.45 5.658v10.4h6.62zM2.528 12.636h6.635V34H2.528V12.636zM5.843 2A3.844 3.844 0 002 5.843C2 7.963 3.721 9.72 5.843 9.72c2.12 0 3.842-1.757 3.842-3.878A3.846 3.846 0 005.843 2z"
            fill={fill}
        />
    </svg>
);

export default Linked;
